export const TILT_DECK_FREIGHT_RULES = {
  deliveryMethod: 'tilt-deck',
  basePriceCents: 50000,
  includedMiles: 20,
  perMileAfterIncludedCents: 475,
  residentialFeeCents: 10000,
  quoteBufferCents: 12500,
  maxAutoQuoteMiles: 400,
};

export const TILT_DECK_ACCESS_COPY =
  'Tilt-deck delivery needs enough clear, level space for a large truck and trailer to enter, turn, unload, and leave safely. Your access road and delivery surface must be suitable for a large truck and trailer. Soft ground, mud, loose gravel, steep grades, tight turns, low overhead clearance, narrow gates, or limited turnaround space may require approval or prevent delivery.';
